
import axios from 'axios';

import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from 'vue';

import PrimeVueTabView from 'primevue/tabview';

import PrimeVueTabPanel from 'primevue/tabpanel';

import {
  SUBSCRIPTION_STATUS_LIVE,
  SUBSCRIPTION_STATUS_DEAD,
} from '@/libs/consts';

import type { SubscriptionStats } from '@/types';

export default defineComponent({
  components: {
    PrimeVueTabView,
    PrimeVueTabPanel,
  },
  props: {
    endpointId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const stats = ref<SubscriptionStats | null>(null);

    const statsLoading = ref(false);

    const statusData = computed(() => {
      if (!stats.value) {
        return [];
      }

      const live = stats.value.subscriptions_by_status[SUBSCRIPTION_STATUS_LIVE] || 0;

      const dead = stats.value.subscriptions_by_status[SUBSCRIPTION_STATUS_DEAD] || 0;

      return [{ live, dead }];
    });

    const datesData = computed(() => {
      if (!stats.value) {
        return [];
      }

      return Object.entries(stats.value.subscriptions_by_days).map(([date, count]) => ({ date, count }));
    });

    const countriesData = computed(() => {
      if (!stats.value) {
        return [];
      }

      return Object.entries(stats.value.subscriptions_by_countries).map(([country, count]) => ({ country, count }));
    });

    const fetchStats = async (): Promise<void> => {
      if (!props.endpointId) {
        return;
      }

      statsLoading.value = true;

      try {
        const response = await axios.post('/api/endpoint/getSubscriptionsStats', {
          endpoint_id: props.endpointId,
        });

        stats.value = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        statsLoading.value = false;
      }
    };

    onMounted(fetchStats);

    return {
      stats,
      statsLoading,
      statusData,
      datesData,
      countriesData,
    };
  },
});
